"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rehydrate = void 0;
var react_dom_1 = require("react-dom");
var React = require("react");
var Config = {
    docType: "<!DOCTYPE html>",
    defaultKeysToFilter: ["settings", "enrouten", "_locals"],
    client: {
        markupId: "react-engine-props",
    },
    staticMarkup: false,
    scriptType: "application/json",
};
var _window, _document;
if (typeof window !== "undefined" && typeof document !== "undefined") {
    _window = window;
    _document = document;
}
// returns the data/state that was
// injected by server during rendering
var data = function data() {
    // this file needs to be a external js file
    var element = document.getElementById(Config.client.markupId);
    // grab the contents from the script element
    var jsonString = element.textContent || element.innerText;
    // parse the text contents to JSON
    return JSON.parse(jsonString);
};
// the client side boot function
function rehydrate(options, callback) {
    var history, viewResolver = options.viewResolver;
    // pick up the state that was injected by server during rendering
    var props = data(), mountNode = options.mountNode || _document;
    // get the file from viewResolver supplying it with a view name
    var view = viewResolver(props.__meta.view);
    // create a react view factory
    var viewFactory = React.createFactory(view);
    // render the factory on the client
    // doing this, sets up the event
    // listeners and stuff aka mounting views.
    react_dom_1.hydrate(viewFactory(props), mountNode);
    // call the callback with the data that was used for rendering
    return callback && callback(props, history);
}
exports.rehydrate = rehydrate;
